import React, { useEffect, useState } from "react";
import bg from "./contactus/formcontactimage.png";

const ContactFormSection = () => {
  const [visible, setVisible] = useState(false);
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    phone: '',
    email: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);

  useEffect(() => {
    setVisible(true); // Trigger animations only once on load
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus(null);

    try {
      const URL = process.env.REACT_APP_BACKEND
      const response = await fetch(`${URL}/api/send-contact-email`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        setSubmitStatus('success');
        // Clear form
        setFormData({
          firstName: '',
          lastName: '',
          phone: '',
          email: '',
          message: ''
        });
      } else {
        setSubmitStatus('error');
      }
    } catch (err) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section className="min-h-screen flex flex-col justify-center  text-center px-4">
      <style>{`
        @keyframes fadeInUp {
          from { opacity: 0; transform: translateY(30px); }
          to { opacity: 1; transform: translateY(0); }
        }
        .fade-in-up {
          opacity: 0;
          animation: fadeInUp 0.8s ease-out forwards;
        }
      `}</style>

      {/* Top Headings */}
      <h2
        className={`text-[26px] sm:text-[30px] md:text-[32px] font-inter text-white ${
          visible ? "fade-in-up" : ""
        }`}
        style={{ animationDelay: "0s", animationFillMode: "forwards" }}
      >
        Get In Touch Today And Experience Clarity, Care And Control
      </h2>
      <h3
        className={`text-[30px] sm:text-[34px] md:text-[36px] font-bold font-satoshi text-[#00B2FF] leading-tight mt-2 ${
          visible ? "fade-in-up" : ""
        }`}
        style={{ animationDelay: "0.2s", animationFillMode: "forwards" }}
      >
        The Big Blue Way.
      </h3>

      {/* Contact Box */}
      <div className="mt-10 mx-auto w-full max-w-[980px] min-h-[500px] relative rounded-[34px] overflow-hidden">
        {/* Background Image */}
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{ backgroundImage: `url(${bg})` }}
        />

        {/* Dark Overlay */}
        <div className={`absolute inset-0 bg-black bg-opacity-75`} />

        {/* Content */}
        <div
          className={`relative z-10 px-6 md:px-10 py-10 flex flex-col lg:flex-row justify-between items-stretch gap-8 h-full ${
            visible ? "fade-in-up" : "opacity-0"
          }`}
          style={{ animationDelay: "0.4s", animationFillMode: "forwards" }}
        >
          {/* Left Info Section */}
          <div className="text-left text-white w-full lg:w-1/2 self-stretch flex flex-col justify-center">
            <h4 className="text-[36px] md:text-[45px] font-bold mb-6">Got A Question</h4>

            <div className="mb-6">
              <div className="flex items-center gap-2 text-[28px] md:text-[35px] font-semibold">
                <svg className="w-7 h-7 md:w-9 md:h-9 text-[#00B2FF]" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5S10.62 6.5 12 6.5 14.5 7.62 14.5 9 13.38 11.5 12 11.5z" />
                </svg>
                Address
              </div>
              <p className="text-[16px] md:text-[20px] font-light mt-1 leading-snug">
                2550 Argentia Road, Mississauga, ON, L5N 5R1 Canada
              </p>
            </div>

            <div className="mb-6">
              <div className="flex items-center gap-2 text-[28px] md:text-[35px] font-semibold">
                <svg className="w-7 h-7 md:w-9 md:h-9 text-[#00B2FF]" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M6.62 10.79a15.05 15.05 0 006.59 6.59l2.2-2.2a1 1 0 011.11-.21 11.36 11.36 0 004.22.8 1 1 0 011 1V20a1 1 0 01-1 1A16 16 0 014 5a1 1 0 011-1h3.5a1 1 0 011 1 11.36 11.36 0 00.8 4.22 1 1 0 01-.21 1.11l-2.47 2.46z" />
                </svg>
                Phone
              </div>
              <p className="text-[16px] md:text-[20px] font-light mt-1 leading-snug">
                +1-289-835-7593
              </p>
            </div>

            <div>
              <div className="flex items-center gap-2 text-[28px] md:text-[35px] font-semibold">
                <svg className="w-7 h-7 md:w-9 md:h-9 text-[#00B2FF]" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M20 4H4a2 2 0 00-2 2v1.5l10 6.25 10-6.25V6a2 2 0 00-2-2zm0 4.75l-8.5 5.25L3 8.75V18a2 2 0 002 2h14a2 2 0 002-2V8.75z" />
                </svg>
                Email
              </div>
              <p className="text-[15px] md:text-[18px] font-light mt-1 leading-snug">
                salessupport@bigblueinc.ca <br />
                customerservice@bigblueinc.ca
              </p>
            </div>
          </div>

          {/* Right Form Section */}
          <form 
            className="w-full lg:w-1/2 grid grid-cols-1 md:grid-cols-2 gap-x-4 gap-y-4 text-left self-stretch content-center"
            onSubmit={handleSubmit}
          >
            {/* Status Messages */}
            {submitStatus === 'success' && (
              <div className="p-3 bg-green-100 text-green-700 rounded-lg col-span-1 md:col-span-2">
                Message sent successfully! We'll get back to you soon.
              </div>
            )}
            {submitStatus === 'error' && (
              <div className="p-3 bg-red-100 text-red-700 rounded-lg col-span-1 md:col-span-2">
                Error sending message. Please try again later.
              </div>
            )}

            <div className="flex flex-col col-span-1">
              <label className="text-white text-[15px] mb-1">First Name</label>
              <input
                type="text"
                name="firstName"
                value={formData.firstName}
                onChange={handleChange}
                required
                className="bg-transparent border border-white text-white text-sm px-4 py-1 rounded-full"
              />
            </div>
            <div className="flex flex-col col-span-1">
              <label className="text-white text-[15px] mb-1">Last Name</label>
              <input
                type="text"
                name="lastName"
                value={formData.lastName}
                onChange={handleChange}
                required
                className="bg-transparent border border-white text-white text-sm px-4 py-1 rounded-full"
              />
            </div>
            <div className="flex flex-col col-span-1">
              <label className="text-white text-[15px] mb-1">Phone Number</label>
              <input
                type="text"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                className="bg-transparent border border-white text-white text-sm px-4 py-1 rounded-full"
              />
            </div>
            <div className="flex flex-col col-span-1">
              <label className="text-white text-[15px] mb-1">E-mail</label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
                className="bg-transparent border border-white text-white text-sm px-4 py-1 rounded-full"
              />
            </div>
            <div className="flex flex-col col-span-1 md:col-span-2">
              <label className="text-white text-[15px] mb-1">Message</label>
              <textarea
                name="message"
                value={formData.message}
                onChange={handleChange}
                rows="4"
                className="bg-transparent border border-white text-white text-sm px-4 py-4 md:py-12 rounded-xl resize-none"
              ></textarea>
            </div>
            <div className="col-span-1 md:col-span-2 mt-2">
              <button
                type="submit"
                disabled={isSubmitting}
                className={`bg-[#00B2FF] text-white text-sm px-6 py-2 rounded-full hover:bg-[#009ddd] transition ${
                  isSubmitting ? 'opacity-70 cursor-not-allowed' : ''
                }`}
              >
                {isSubmitting ? (
                  <>
                    <svg 
                      className="animate-spin -ml-1 mr-2 h-4 w-4 text-white inline" 
                      xmlns="http://www.w3.org/2000/svg" 
                      fill="none" 
                      viewBox="0 0 24 24"
                    >
                      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                      <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                    </svg>
                    Sending...
                  </>
                ) : 'Send a Message'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </section>
  );
};

export default ContactFormSection;